import {
    type GetAllContactFormsResponseType,
    type GetAllContactFormsRequestType
} from "./type";
import {
    request
} from "../request";

const getAllContactForms = async (
    params: GetAllContactFormsRequestType
): Promise<GetAllContactFormsResponseType> => {
    const searchParams = new URLSearchParams();

    const effectiveFilter = params.authType || params.filter;

    if(effectiveFilter) {
        searchParams.append("authType", effectiveFilter);
        searchParams.append("filter", effectiveFilter);
    }

    if(params.status && params.status !== "all") {
        searchParams.append("status", params.status);
    }

    if(params.isRead !== undefined) {
        searchParams.append("isRead", String(params.isRead));
    }

    if(params.search) {
        searchParams.append("search", params.search);
    }

    if(params.page !== undefined) {
        searchParams.append("page", String(params.page));
    }

    const queryStr = searchParams.toString();
    const endpoint = queryStr ? `/request/getAllContactForms?${queryStr}` : "/request/getAllContactForms";

    return await request<GetAllContactFormsResponseType>(endpoint, {
        method: "GET"
    });
};
export default getAllContactForms;
